module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Shutdown-a28a600898c59af28ac3ed7de76bcd0b.svg";